"use strict";

import { appendQueryParams } from "../util/urlHelpers";
import constants from "../constants";
import gtm from "../gtm";

const initAddToCartListener = () => {
    const $cartConflictModal = $(".js-cart-conflict-modal");
    const $planConflictModal = $(".js-plan-conflict-modal");
    let isAddingToCart       = false;

    $(".js-offerTile-cta-subscribe, .js-offer-banner").on("click", function (e) {
        e.preventDefault();
        const $buttonElement    = $(this);
        const isBannerLink      = $buttonElement.hasClass("js-offer-banner");
        const isLandingPageLink = $buttonElement.hasClass("js-landing-page-subscribe");
        const redirectUrl       = $buttonElement.attr("data-redirect-url");
        const isNBOSelected     = $buttonElement.data("nbo-selected");

        // If the user is already making an Ajax call to add the product to cart, we don't want to make another one.
        if (isAddingToCart) {
            return;
        }

        const offerSource = isBannerLink
            ? constants.ADD_PRODUCT_TO_CART_SOURCE.OFFER_BANNER
            : isLandingPageLink
                ? constants.ADD_PRODUCT_TO_CART_SOURCE.LANDING_PAGE
                : constants.ADD_PRODUCT_TO_CART_SOURCE.OFFER_TILE;

        if (isBannerLink) {
            $buttonElement.addClass("banner-loading");
            const $swiperContainer = $buttonElement.parents(".swiper");

            // Pause the autoplay of the swiper slide case there is one
            if ($swiperContainer.length !== 0) {
                const swiperObj = $swiperContainer.get(0).swiper;

                swiperObj.autoplay.stop();
                swiperObj.pagination.disable();
                swiperObj.allowTouchMove = false;
            }
        } else {
            $buttonElement.removeClass("btn-primary-cta-buy").addClass("btn-primary-cta-buy-loading");
        }

        if (!$buttonElement.attr("data-add-to-cart") && !isBannerLink) {
            window.location.href = redirectUrl;
            return;
        }

        const url                = appendQueryParams($buttonElement.attr("data-offer-url"), {
            source: offerSource,
            redirectToCheckout: $buttonElement.data("should-redirect-to-checkout"),
            nboSelected: isNBOSelected,
        });
        const $minicartContainer = $(".js-minicart");
        const isOnPlanChangeFlow = $minicartContainer.data("on-change-plan-flow");

        // Modal that appears when the customer abandoned a plan change flow and tries to add something to the cart.
        if (isOnPlanChangeFlow) {
            const $planConflictModalBtn = $(".js-plan-conflict-submit");

            $planConflictModalBtn.attr("data-redirect-url", redirectUrl);
            $planConflictModalBtn.attr("is-add-product", true);
            $planConflictModal.data("url", url);
            $planConflictModal.toggleClass("show", true);

            if ($buttonElement.hasClass("gtm-banner")) {
                localStorage.setItem("conflictProductId", $buttonElement.attr("id"));
            } else {
                localStorage.setItem("conflictProductId", $buttonElement.parents(".js-offer-tile").attr("id"));
            }

            return;
        }

        // Set flag to stop following clicks until the Ajax call is done
        isAddingToCart = true;

        $.ajax({
            url: url,
            type: "get",
            dataType: "json"
        }).done(function (response) {
            // Modal should be shown in FD to ask the user if he wants to empty the current cart.
            if (response.isEmptyCartRequired) {
                const $cartConflictModalBtn = $(".js-cart-conflict-submit");

                $cartConflictModalBtn.attr("data-redirect-url", redirectUrl);

                $cartConflictModal.data("url", url);
                $cartConflictModal.toggleClass("show", true);

                if ($buttonElement.hasClass("gtm-banner")) {
                    localStorage.setItem("conflictProductId", $buttonElement.attr("id"));
                } else {
                    localStorage.setItem("conflictProductId", $buttonElement.parents(".js-offer-tile").attr("id"));
                }

                // The flag for multiple request should be only set to false in this case, because on another ones the user is being redirected
                // To another page and no further interactions should be allowed.
                isAddingToCart = false;
                return;
            }

            if (response.isViabilityRequired) {
                window.location.href = response.viabilityCheckUrl;
            } else {
                if ($buttonElement.hasClass("gtm-banner")) {
                    gtm.trackSelectPromotion($buttonElement, constants.GTM.EVENTS.SELECT_PROMOTION);
                    gtm.trackSelectPromotion($buttonElement, constants.GTM.EVENTS.ADD_TO_CART);
                } else {
                    if (!response.isEmptyCartRequired && !isLandingPageLink) {
                        gtm.cartEvents($buttonElement, constants.GTM.EVENTS.ADD_TO_CART);
                    }
                }

                const segment = $(".js-header-tab.active li").first().text().trim();

                if (segment) {
                    localStorage.setItem("gtmSegment", $(".js-header-tab.active li").first().text().trim());
                }

                window.location.href = redirectUrl || response.cartUrl;
            }
        });
    });

    const onConflictResolutionSubmit = (submitUrl, redirectUrl) => {
        $.ajax({
            url: submitUrl,
            type: "get",
            dataType: "json",
        }).done(function (response) {
            if (response.canAddProductToCart && !response.isViabilityRequired) {
                gtm.trackRemoveFromCart();
                const sessionProductId = localStorage.getItem("conflictProductId");
                var conflictProduct;

                if (sessionProductId.indexOf("banner") !== -1) {
                    conflictProduct = $(".gtm-banner[id=" + sessionProductId + "]");
                    gtm.trackSelectPromotion(conflictProduct, constants.GTM.EVENTS.SELECT_PROMOTION);
                    gtm.trackSelectPromotion(conflictProduct, constants.GTM.EVENTS.ADD_TO_CART);
                } else {
                    conflictProduct = $(".js-offer-tile[id=" + sessionProductId + "]").find(".btn-primary-cta-buy");
                    gtm.cartEvents(conflictProduct, constants.GTM.EVENTS.ADD_TO_CART);
                }

                const segment = $(".js-header-tab.active li").first().text().trim();

                if (segment) {
                    localStorage.setItem("gtmSegment", $(".js-header-tab.active li").first().text().trim());
                }

                localStorage.removeItem("conflictProductId");
                window.location.href = redirectUrl || response.cartUrl;
            } else if (response.isViabilityRequired) {
                window.location.href = response.viabilityCheckUrl;
            }
        });
    };

    $(".js-cart-conflict-submit", $cartConflictModal).on("click", function () {
        const submitUrl = appendQueryParams($cartConflictModal.data("url"), {
            emptyCart: true
        });

        isAddingToCart    = true;
        const redirectUrl = $(this).attr("data-redirect-url");

        onConflictResolutionSubmit(submitUrl, redirectUrl);
    });

    $(document).on("click", ".js-plan-conflict-submit[is-add-product='true']", function () {
        const submitUrl = appendQueryParams($planConflictModal.data("url"), {
            emptyCart: true
        });

        isAddingToCart    = true;
        const redirectUrl = $(this).attr("data-redirect-url");

        onConflictResolutionSubmit(submitUrl, redirectUrl);
    });
};

const setUpConflictWithCartItemsModalListeners = () => {
    const $cartConflictModal = $(".js-cart-conflict-modal");
    const $planConflictModal = $(".js-plan-conflict-modal");

    const onConflictModalClose = () => {
        $cartConflictModal.toggleClass("show", false);
        $planConflictModal.toggleClass("show", false);

        $(".js-offerTile-cta-subscribe")
            .removeClass("btn-primary-cta-buy-loading")
            .addClass("btn-primary-cta-buy");

        const $offerBanners = $(".js-offer-banner.banner-loading");

        // Remove loading banner visual and resume autoplay of swiper carousel if necessary.
        if ($offerBanners.length !== 0) {
            $offerBanners.removeClass("banner-loading");
            const $swiperContainer = $offerBanners.parents(".swiper");

            if ($swiperContainer.length !== 0) {
                const swiperObj = $swiperContainer.get(0).swiper;

                swiperObj.autoplay.resume();
                swiperObj.pagination.enable();
                swiperObj.allowTouchMove = true;
            }
        }
    };

    $(".js-cart-conflict-close", $cartConflictModal).on("click", onConflictModalClose);
    $(".js-plan-conflict-close", $planConflictModal).on("click", onConflictModalClose);
};

const setUpAdditionalServicesListeners = () => {
    const $modal          = $(".js-basic-modal");

    $(document).on("click", ".js-offer-tile-addon", function () {
        const $offerTileAddOn = $(this);
        const title           = "+ " + $offerTileAddOn.data("short-description");
        const description     = $offerTileAddOn.data("long-description");

        $modal.find(".modal__title").html(title);
        $modal.find(".modal__body p").html(description);
        $modal.toggleClass("show", true);
    });
};

const setUpMoreInfoListeners = () => {
    const $offerTileModalContainer = $(".js-more-info-modal");

    if ($offerTileModalContainer.length === 0) {
        return;
    }

    const serviceAssets = $(".more-info-modal__service-grid-content");

    serviceAssets.each(function () {
        const htmlContent = $(this).find("p").text();
        const paragraph   = $(this).find("p");

        paragraph.html(htmlContent);
    });

    $(document).on("click", ".js-offer-tile-more-info", function () {
        const $moreInfoButton         = $(this);
        const $offerTileContainer     = $moreInfoButton.parents(".js-offer-tile");
        const $productMoreInfoContent = $(".js-offer-tile-more-info-content", $offerTileContainer);

        gtm.cartEvents($moreInfoButton, constants.GTM.EVENTS.SELECT_ITEM);

        $offerTileModalContainer.toggleClass("show");

        $productMoreInfoContent.children().clone().appendTo(".js-more-info-modal-content", $offerTileModalContainer);
        gtm.cartEvents($moreInfoButton, constants.GTM.EVENTS.VIEW_ITEM);
    });
};

const initPromotionCard = () => {
    if ($(".countDownContainer").length === 0) {
        return;
    }

    $(".countDownContainer").countdown();
    $(".countDownContainer").on("countdown:update", function (evt, data) {
        const formatNumbers = (value) => value.toString().padStart(2, "0");

        $(this).html(`<i class="icon-clock-stop-watch"></i> ${data.days ? data.days + "D " : ""}${formatNumbers(data.hour)}:${formatNumbers(data.min)}:${formatNumbers(data.sec)}`);
    });

    $(".countDownContainer").on("countdown:finished", function () {
        $(this).closest(".js-offer-tile").parent().remove();
    });
};

const setUpModalInteractionsListeners = () => {
    const $offerTileModalContainer     = $(".js-more-info-modal");
    const $offerTileModalContent       = $(".js-more-info-modal-content", $offerTileModalContainer);
    const $secondaryProductModalDialog = $(".more-info-modal__dialog.product-secondary-modal-banner");

    $(".js-more-info-modal-close", $offerTileModalContainer).on("click", () => {
        $secondaryProductModalDialog.toggleClass("close-animation", true);
        setTimeout(() => {
            $secondaryProductModalDialog.toggleClass("close-animation", false);
            $offerTileModalContainer.toggleClass("show");
            $offerTileModalContent.empty();
        }, 500);
    });

    $offerTileModalContainer.on("click", (e) => {
        const $clicked = $(e.target);

        if ($clicked.is($offerTileModalContainer)) {
            $secondaryProductModalDialog.toggleClass("close-animation", true);

            setTimeout(() => {
                $secondaryProductModalDialog.toggleClass("close-animation", false);
                $offerTileModalContainer.toggleClass("show");
                $offerTileModalContent.empty();
            }, 500);
        }
    });
};

const initListeners = () => {
    console.log("offerTile.js loaded");
    initAddToCartListener();
    setUpAdditionalServicesListeners();
    setUpMoreInfoListeners();
    setUpModalInteractionsListeners();
    setUpConflictWithCartItemsModalListeners();
    initPromotionCard();
};

export default initListeners;
